import { List, Record as record } from 'immutable';

import { construct, resolveAll } from '../../helpers/LinkMapper';

import PaymentResponse from './PaymentResponse';
import CocsResponse from './CocsResponse';

const defaults = {
    cocs: null,
    payments: new List()
};


class AuthResponse extends record(defaults) {

    static fromJSON (json = {}) {
        if (!json.payments) {
            return new AuthResponse({
                cocs: CocsResponse.fromJSON(json)
            });
        }

        return construct(AuthResponse, json, {
            payments: resolveAll.as(PaymentResponse)
        });
    }

    isSuccess () {
        if (this.cocs) {
            return this.cocs.isSuccess();
        }
        return this.payments && this.payments.every(p => p.success);
    }

    isFraud () {
        if (this.cocs) {
            return this.cocs.isFraud();
        }
        return false;
    }

    isEnrolled () {
        if (this.cocs) {
            return this.cocs.isEnrolled();
        }
        return false;
    }

    isError () {
        if (this.cocs) {
            return this.cocs.isError();
        }
        return this.payments && this.payments.some(p => !p.success);
    }

    isProcessing () {
        if (this.cocs) {
            return this.cocs.isProcessing();
        }
        return this.payments && this.payments.some(p => p.processing);
    }

    get id () {
        return this.getIn(['cocs', 'id']);
    }
    get status () {
        return this.getIn(['cocs', 'status']);
    }
    get code () {
        return this.getIn(['cocs', 'code']);
    }
    get md () {
        return this.getIn(['cocs', 'md']);
    }
    get pareq () {
        return this.getIn(['cocs', 'pareq']);
    }
    get redirect () {
        return this.getIn(['cocs', 'redirect']);
    }
    get message () {
        return this.getIn(['cocs', 'message']);
    }

}


export default AuthResponse;



// WEBPACK FOOTER //
// ./src/records/payment/AuthResponse.js